import next_prev from "./common/next_prev";
const nextPrev = next_prev('stock_next_prev_state')
const saveState = nextPrev.saveState //use this function to save the state..
const state = {
    ...nextPrev.state,
}
const getters = {
    ...nextPrev.getters,
}
const actions = {
    ...nextPrev.actions,
}
const mutations = {
    ...nextPrev.mutations,
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/stock_nextprev.js